window.dataLayer = window.dataLayer || []

/**
 * @description: PLP Select Size
 */
if (document.querySelector('[data-ga-size-el="plpSizeClick"]')) {
  document.querySelectorAll('[data-ga-size-el="plpSizeClick"]').forEach(input => {
    input.addEventListener('click', event => {
      window.dataLayer.push({
        event: 'plp_size_click',
        plpSize: {
          size_availability: event.target.dataset.gaVariableAvailable,
          product_name: event.target.dataset.gaVariableProduct,
          size_selected: event.target.dataset.gaVariableSize,
        },
      })
    })
  })
}

/**
 * @description: PLP sub-collection link click
 */
const subCollectionLinkEls = document.querySelectorAll('[data-ga-el="subCollectionLink"]')
if (subCollectionLinkEls.length) {
  subCollectionLinkEls.forEach(linkEl => {
    linkEl.addEventListener('click', event => {
      window.dataLayer.push({
        event: 'plp_quick_links',
        dlv: {
          target_text: event.currentTarget.innerText,
        },
      })
    })
  })
}

/**
 * @description: Paginated PLP click
 */
const paginationEls = document.querySelectorAll('[data-ga-el="pagination"]')
if (paginationEls.length > 0) {
  paginationEls.forEach(el => {
    el.addEventListener('click', event => {
      const { gaPage, gaAction, gaCollection, gaPageSize } = event.target.dataset

      window.dataLayer.push({
        event: 'paginated_plp_click',
        paginatedPLPClick: {
          current_page: gaPage,
          click_action: gaAction,
          item_list_name: gaCollection,
          page_size: gaPageSize,
        },
      })
    })
  })
}
